/**
 * Object containing all localStorage keys used across the app
 */
export const STORAGE_KEYS = {
  NOTIFICATIONS: 'app_notification_settings',
  USER_PREFERENCES: 'app_user_preferences',
  USER: 'app_user',
  ACCESSIBILITY: 'app_accessibility_settings',
} as const
